import agent, { identityUrl } from 'api/agent';

export const User = {
    GetUserRestaurants: () => agent.requests.get('/Restaurant/userrestaurants'),
    SetUserCurrentRestaurant: (id: string) => agent.requests.post(`/User/currentrestaurant/${id}`),
    GetUserProfile: () => agent.requests.get(`${identityUrl}/Account/GetProfile`),
};
